import {mapGetters} from 'vuex'

export default {
  data() {
    return {
      actionsByGroup: {
        project: ['projectInfo', 'projectUpdate', 'projectUsage', 'projectCreate', 'projectDestroy'],
        host: ['hostInfo', 'hostUpdate', 'hostUsage', 'hostTerminal', 'hostCreate', 'hostDestroy'],
        service: ['serviceInfo', 'serviceUpdate', 'serviceScale', 'serviceTerminal', 'serviceMoveContainer', 'serviceChangeProject', 'serviceDestroy'],
        provider: ['providerCreate', 'providerUpdate', 'providerDestroy'],
        key: ['keyCreate', 'keyDestroy'],
        account: ['accManagement', 'tariffManagement'],
      },
      rulesByGroup: {
        project: ['projectInfo', 'projectUpdate', 'projectUsage', 'projectDestroy', 'serviceInfo', 'serviceUpdate', 'serviceTerminal', 'serviceMoveContainer', 'serviceScale', 'serviceChangeProject', 'serviceDestroy'],
        host: ['hostInfo', 'hostUpdate', 'hostUsage', 'hostTerminal', 'hostDestroy'],
        service: ['serviceInfo', 'serviceUpdate', 'serviceTerminal', 'serviceScale', 'serviceMoveContainer', 'serviceChangeProject', 'serviceDestroy'],
      },
      namesByAction: {
        accManagement: 'Access control',
        hostCreate: 'Create',
        hostDestroy: 'Delete',
        hostInfo: 'View',
        hostTerminal: 'Terminal',
        hostUpdate: 'Resize and update',
        hostUsage: 'Deploy services',
        keyCreate: 'Add',
        keyDestroy: 'Delete',
        projectCreate: 'Create',
        projectDestroy: 'Delete',
        projectExport: 'Export',
        projectInfo: 'View',
        projectUpdate: 'Rename',
        projectUsage: 'Deploy services',
        providerCreate: 'Add',
        providerDestroy: 'Destroy data',
        providerUpdate: 'Update credentials',
        serviceChangeProject: 'Change project',
        serviceDestroy: 'Delete',
        serviceInfo: 'View',
        serviceMoveContainer: 'Move containers',
        serviceScale: 'Scale',
        serviceTerminal: 'Terminal',
        serviceUpdate: 'Update',
        tariffManagement: 'Tariff management',
      },
      classByValue: {
        undefined: 'notdefined',
        0: 'defined red',
        1: 'defined green',
      },
      iconsByValue: {
        undefined: 'grey times circle',
        0: 'red times circle',
        1: 'green check circle',
      },
      selectedTemplate: null,
      basicTemplates: [
        {
          name: 'Empty',
          active: true,
          actions: {},
        },
        {
          name: 'Guest',
          active: true,
          actions: {
            hostInfo: 1,
            projectInfo: 1,
            serviceInfo: 1,
          },
        },
        {
          name: 'Dev',
          active: true,
          actions: {
            hostInfo: 1,
            hostUsage: 1,
            keyCreate: 1,
            projectCreate: 1,
            projectDestroy: 1,
            projectExport: 1,
            projectInfo: 1,
            projectUpdate: 1,
            projectUsage: 1,
            serviceInfo: 1,
            serviceUpdate: 1,
          },
        },
        {
          name: 'Admin',
          active: true,
          actions: {
            accManagement: 1,
            hostCreate: 1,
            hostDestroy: 1,
            hostInfo: 1,
            hostTerminal: 1,
            hostUpdate: 1,
            hostUsage: 1,
            keyCreate: 1,
            keyDestroy: 1,
            projectCreate: 1,
            projectDestroy: 1,
            projectExport: 1,
            projectInfo: 1,
            projectUpdate: 1,
            projectUsage: 1,
            providerCreate: 1,
            providerDestroy: 1,
            providerUpdate: 1,
            serviceChangeProject: 1,
            serviceDestroy: 1,
            serviceInfo: 1,
            serviceMoveContainer: 1,
            serviceScale: 1,
            serviceTerminal: 1,
            serviceUpdate: 1,
          },
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['member', 'members', 'role', 'roles']),
    templates() {
      const templates = []
      for (const role of this.roles) {
        templates.push({icon: 'tag', value: `role:${role.name}`, text: role.name, actions: role.actions})
      }
      for (const member of this.members) {
        templates.push({icon: 'user', value: `member:${member.name}`, text: member.name, actions: member.actions})
      }
      for (const template of this.basicTemplates) {
        if (template.active && !templates.find(t => t.text === template.name)) {
          templates.unshift({icon: 'grey tag', value: `example:${template.name}`, text: template.name, actions: template.actions})
        }
      }
      return templates
    },
  },
  watch: {
    selectedTemplate() {
      this.entity.actions = this.templates.find(template => template.value === this.selectedTemplate).actions
    },
  },
}
